import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { select, Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CatalogActions } from './store/actions';
import { CATALOG_FEATURE, CatalogState, StateWithCatalog } from './store/catalog-state';
import { CatalogSelectors } from './store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CatalogStatePersistenceService {
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected store: Store<StateWithCatalog>,
    private baseStores: BaseStoreFacade,
  ) {}

  public sync(): void {
    this.statePersistenceService.syncWithStorage({
      key: CATALOG_FEATURE,
      state$: this.getState(),
      context$: this.baseStores.getActiveCode(),
      storageType: StorageSyncType.SESSION_STORAGE,
      onRead: (state: CatalogState | undefined) => (state ? this.onRead(state) : undefined),
    });
  }

  protected getState(): Observable<CatalogState> {
    return this.store.pipe(select(CatalogSelectors.getFeatureState));
  }

  protected onRead(state: CatalogState): void {
    if (state && state.catalog?.value) {
      this.store.dispatch(new CatalogActions.CatalogSetState(state.catalog.value));
    }
  }
}
